import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import StatisticCard from "../../stats/components/StatisticCard";

const ProUpgradeCard = ({ title }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="relative">
      <div className="blur-sm pointer-events-none">
        <StatisticCard title={title} hint={t("history.gameHistory.proFeature")}>
          <div className="h-64 bg-secondary rounded-lg flex items-center justify-center">
            <p className="text-white text-xl">
              {t("history.gameHistory.proFeature")}
            </p>
          </div>
        </StatisticCard>
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/50 rounded-lg">
        <p className="text-white text-xl font-bold mb-2">
          {t("history.gameHistory.proFeature")}
        </p>
        <p className="text-white text-center mb-4">
          {t("history.gameHistory.upgradeToPro")}
        </p>
        <button
          onClick={() => navigate("/settings")}
          className="bg-test hover:bg-secondary text-primary px-6 py-2 rounded-full shadow-sm transition duration-200"
        >
          {t("history.gameHistory.upgrade")}
        </button>
      </div>
    </div>
  );
};

export default ProUpgradeCard;
